import { formatDate } from 'date-fns';
import { DiscountType, ReleaseType } from '@ibk/shared-types';
import { getUnformatedValue } from '../../../../utils';
const onlyDigits = (value) => (value ?? '').replace(/\D/g, '');
export function resolveCalculationType(releaseType) {
    return releaseType === ReleaseType.DAILY ? 'DAILY' : 'MONTHLY';
}
export function resolveDiscountType(discountType, payrollDeduction) {
    if (!payrollDeduction) {
        return null;
    }
    if (discountType === DiscountType.TOTAL) {
        return 'FIXED_VALUE';
    }
    if (discountType === DiscountType.PERCENTAGE) {
        return 'PERCENTAGE';
    }
    return null;
}
export function mapAddressToOrderAddress(address) {
    if (!address) {
        return null;
    }
    return {
        street: address.address,
        number: address.number,
        neighborhood: address.addressLine2 ?? '',
        postalCode: onlyDigits(address.zipCode),
        city: address.city,
        state: address.state,
        complement: address.complement ? address.complement : null,
    };
}
export function mapSelectedBeneficiaryToOrderBeneficiary(selected, calculationType, discountType) {
    const beneficiary = {
        beneficiaryId: selected.beneficiaryId,
        amount: selected.value,
    };
    if (calculationType === 'DAILY' && selected.daysQuantity !== undefined) {
        beneficiary.daysQuantity = Math.round(selected.daysQuantity);
    }
    if (selected.discountValue !== undefined && selected.discountValue !== null) {
        if (discountType === 'FIXED_VALUE') {
            beneficiary.discountValue = selected.discountValue;
        }
        else if (discountType === 'PERCENTAGE') {
            beneficiary.discountPercentage = selected.discountValue;
        }
    }
    return beneficiary;
}
export function mapFormDataToCreateOrderBody({ formData, address, }) {
    const calculationType = resolveCalculationType(formData.releaseType);
    const discountType = resolveDiscountType(formData.discountType, formData.payrollDeduction);
    const orderAddress = mapAddressToOrderAddress(address);
    if (!orderAddress) {
        throw new Error('Missing delivery address');
    }
    const trimmedDescription = formData.rechargeIdentification?.trim() ?? '';
    return {
        description: trimmedDescription.length > 0 ? trimmedDescription : null,
        productId: formData.voucherTypeId ?? '',
        calculationType,
        discountType,
        discountValue: discountType && formData.discountValue ? getUnformatedValue(formData.discountValue) : null,
        baseValue: formData.globalValue ? getUnformatedValue(formData.globalValue) : null,
        daysQuantity: calculationType === 'DAILY' ? (formData.businessDays ?? null) : null,
        address: orderAddress,
        scheduledCreditDate: formData.creditDate ? formatDate(formData.creditDate, 'yyyy-MM-dd') : '',
        competenceDate: formData.competenceDate ? formatDate(formData.competenceDate, 'yyyy-MM') : '',
        beneficiaries: (formData.selectedBeneficiariesList ?? []).map(selected => mapSelectedBeneficiaryToOrderBeneficiary(selected, calculationType, discountType)),
    };
}
